$(document).ready(function(){
//doc ready:
    initVideoCover();

    $( window ).resize(function() {
    initVideoCover();
    });
 //doc ready end
})

/* INIT VIDEOS */
function initVideoCover() {
	$('.initVideo').each(function () {
		var video = $(this);
		var size;
		if (window.matchMedia('(max-width:580px), (orientation: portrait)').matches) {
			size = 'mobile';
		} else if (window.matchMedia('(max-width:1280px)').matches) {
			size = 'small';
		} else if (window.matchMedia('(max-width:1920px)').matches) {
			size = 'medium';
		} else {
			size = 'large';
		}
		video.append("<source src='" + $(video).data(size) + "' type='video/mp4'>");
	});
}
/* END INIT VIDEOS */